import React, { useState } from "react";
import { Badge } from "../../../../../UI toolkit/Button/Button";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import {
  TransactionsTableStyle,
  TransactionsTableHeaderStyle,
} from "./P2PAds.styled";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { connect } from "react-redux";
import {
  capitalizeFirstLetter,
  formatLargeNumber,
} from "../../../../../utils/specialFunctions";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import ic_swapped_coin from "../../../../../assets/images/ic-swapped-coin.svg";
import P2PAdsModal from "./P2PAdsModal";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const P2PAdsTable = ({ links1, pagination, getSavings }) => {
  const [openModal, setopenModal] = useState(false);
  const [ad, setAd] = React.useState(null);

  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "pending",
    paid: "paid",
  };

  const bgColor = (isActive) => {
    return isActive ? "#D1F7C4" : "#FFDCE5";
  };

  const color = (isActive) => {
    return isActive ? "#606060" : "#531423";
  };

  const rowsOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <TransactionsTableHeaderStyle className="w-full">
        <tbody className="w-full">
          <tr className="Table-heading -px-1.5">
            <td width="20%" className="pt-4 pb-4"></td>

            <td width="15%" className="pt-4 pb-4">
              USER
            </td>

            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  AD PRICE
                </SubHeader>
              </div>
            </td>
            <td width="10%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  QUANTITY
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  LIMIT
                </SubHeader>
              </div>
            </td>

            <td width="25%" className="pt-4 pb-4"></td>
          </tr>
        </tbody>
      </TransactionsTableHeaderStyle>
      {links1 &&
        links1.map((transactionGroup, idx, arr) => {
          return (
            <TransactionsTableStyle className="w-full" key={idx}>
              <tbody>
                <tr>
                  <td colSpan="5">
                    <div className="pt-4 pb-4 px-1.5">
                      <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                        {`${timeAgo.format(
                          new Date(transactionGroup.group)
                        )} — ${new Date(
                          transactionGroup.group
                        ).toDateString()}`}
                      </P>
                    </div>
                  </td>
                </tr>

                {transactionGroup.data.map((curr, idx, arr) => {
                  return (
                    // <pre>{JSON.stringify(curr, null, 2)}</pre>
                    <tr
                      className="px-1.5"
                      style={{ borderBottom: "1px solid #EFF0F5" }}
                      key={idx}
                    >
                      <td
                        width="20%"
                        className="pt-4 pb-4 col-start-1 col-end-2"
                      >
                        <div className="flex">
                          <div className="pr-2">
                            <img
                              src={
                                curr.action === "buy"
                                  ? ic_sent_icon
                                  : curr.action === "sell"
                                  ? ic_receive_icon
                                  : null
                              }
                              className="h-auto w-auto"
                              alt="action-icon"
                            />
                          </div>
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {curr.action === "buy" ? "Buy ad" : "Sell ad"}
                            </P>
                            <P fontSize="10px" color={"#7A809B"}>
                              {
                                new Date(curr.created_at)
                                  .toLocaleString()
                                  .split(",")[1]
                              }
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%" className="col-start-2 col-end-4">
                        <div>
                          <P fontSize="13px" color={"#7A809B"} fontWeight="400">
                            {curr?.account?.email}
                          </P>
                          <P fontSize="10px" color={"#7A809B"} fontWeight="500">
                            {curr?.p2p_profile?.username}
                          </P>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center items-start">
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            NGN {curr?.price}/ USDT
                          </P>
                        </div>
                      </td>

                      <td width="10%">
                        <div>
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            {`${
                              curr?.action === "sell"
                                ? curr?.source_currency
                                : curr?.action === "buy"
                                ? curr?.destination_currency
                                : ""
                            }${Number(curr?.quantity).toFixed(2)}`}
                          </P>
                          <P fontSize="10px" color={"#374072"} fontWeight="500">
                            NGN
                            {Number(curr?.quantity * curr?.price)
                              .toFixed(2)
                              .toLocaleString()}
                          </P>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              NGN {formatLargeNumber(curr.lower_limit)} -
                              {formatLargeNumber(curr.upper_limit)}
                            </P>
                            <P
                              fontSize="10px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {curr?.price_type}
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="10%" className="pt-4 pb-4 px-1.5">
                        <Badge
                          color={color(curr.is_active)}
                          bg={bgColor(curr.is_active)}
                        >
                          {curr.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>

                      <td width="15%" className="pt-4 pb-4 px-1.5">
                        <div className="flex">
                          <div className="">
                            <P
                              fontSize="13px"
                              color={"#0087B5"}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setAd(curr);
                                setopenModal(true);
                              }}
                            >
                              View
                            </P>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </TransactionsTableStyle>
          );
        })}
      <div>
        {openModal ? (
          <P2PAdsModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            ad={ad}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pagination: state.savings.pagination,
  };
};

// Link Actions to components
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(P2PAdsTable);
